<template>
    <!-- <v-card color="grey lighten-2"> -->
    <!-- Container para Información: -->
    <v-container>
        <v-layout row justify-space-around>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs12 sm11 elevation-6>
                <div class="sub-window">
                    <v-container pa-1 grid-list-md>
                        <!-- Encabezado con el título de la subventana y el botón para cerrarla: -->
                        <v-layout row>
                            <v-flex xs10 class="text-left">
                                <div
                                    class="text-left display-1 font-weight-bold teal--text text--lighten-2"
                                >{{ $t('title')}}</div>
                            </v-flex>
                            <v-flex xs2 class="text-right">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn text @click="onClose" v-on="on">
                                            <v-icon color="teal lighten-1">mdi-close</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{ $t('btn-cerrar')}}</span>
                                </v-tooltip>
                            </v-flex>
                        </v-layout>
                        <v-divider class="teal lighten-1"></v-divider>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <v-card class="mx-auto transparent" width="100%" elevation="0">
                                    <v-card-text class="teal--text text--lighten-5 text-sm-left">
                                        {{ $t('p1')}}
                                    
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12>
                                                    <v-list dark dense two-line>
                                                        <v-list-item @click="onDoc1">
                                                            <v-list-item-avatar>
                                                                <v-icon
                                                                    color="red"
                                                                >mdi-file-pdf-box</v-icon>
                                                            </v-list-item-avatar>
                                                            <v-list-item-content>
                                                                <v-list-item-title>The future of HR: From flux to flow</v-list-item-title>
                                                                <v-list-item-subtitle>How Pathfinders are grappling with the current challenges faced by the function and are moving towards 2025 with purpose</v-list-item-subtitle>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                        <v-list-item @click="onDoc2">
                                                            <v-list-item-avatar>
                                                                <v-icon
                                                                    color="red"
                                                                >mdi-file-pdf-box</v-icon>
                                                            </v-list-item-avatar>
                                                            <v-list-item-content>
                                                                <v-list-item-title>DHR GLobal 2025 Workforce Trends Report Final</v-list-item-title>
                                                                <v-list-item-subtitle>The Impact of AI, Executive Turnover, and More</v-list-item-subtitle>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                        <v-list-item @click="onDoc3">
                                                            <v-list-item-avatar>
                                                                <v-icon
                                                                    color="red"
                                                                >mdi-file-pdf-box</v-icon>
                                                            </v-list-item-avatar>
                                                            <v-list-item-content>
                                                                <v-list-item-title>Future of Jobs Report - World Economic Forum</v-list-item-title>
                                                                <v-list-item-subtitle>Insight Report, January 2025</v-list-item-subtitle>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                        <v-list-item @click="onDoc4">
                                                            <v-list-item-avatar>
                                                                <v-icon
                                                                    color="red"
                                                                >mdi-file-pdf-box</v-icon>
                                                            </v-list-item-avatar>
                                                            <v-list-item-content>
                                                                <v-list-item-title>HR Trends Report 2025</v-list-item-title>
                                                                <v-list-item-subtitle>Academy to Innovate HR</v-list-item-subtitle>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                    </v-list>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>

                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </div>
            </v-flex>
        </v-layout>
    </v-container>
    <!-- </v-card> -->
    <!-- Fin container para toda la página ********************************************* -->
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'Recursos',
    data() {
        return {
            
        };
    },
    created()
    {
    },
    methods:
    {
        onDoc1()
        {
            window.open('https://www.retroalimentame.com.mx/informacion/downloads/the-future-of-hr-report kpmg.pdf');
        },
        onDoc2()
        {
            window.open('https://www.retroalimentame.com.mx/informacion/downloads/DHR-Global_2025_Workforce_Trends_Report_Final.pdf');
        },
        onDoc3()
        {
            window.open('https://www.retroalimentame.com.mx/informacion/downloads/WEF_Future_of_Jobs_Report_2025.pdf');
        },
        onDoc4()
        {
            window.open('https://www.retroalimentame.com.mx/informacion/downloads/AIHR_HR_Trends_Report_2025.pdf');
        },
        onClose()
        {
            this.showDocumentosInteresTxt = false;
        }
    },
    computed: {
        ...mapGetters(['waitCursor']),
        showDocumentosInteresTxt:
        {
            get()
            {
                return this.$store.getters.showDocumentosInteresTxt;
            },
            set(showDocumentosInteresTxt)
            {
                this.$store.dispatch('updateShowDocumentosInteresTxt', showDocumentosInteresTxt);
            }
        }
    }
};
</script>

<i18n>
{
    "es": {
        "title": "Documentos de Interés",
        "p1": "A continuación presentamos algunos documentos de interés:"
    },
    
    "en": {
        "title": "Documents of Interest",
        "p1": "Below are some documents of interest:"
    }
}
</i18n>

<style scoped>
.sub-window {
    /* background: rgba(0, 77, 64, 0.6); */
    background: rgba(26, 32, 38, 0.84);
}
</style>